"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyValueDescription = exports.PropertyValueContainer = exports.StyledP = exports.PropertyContainer = exports.HelpContainer = exports.DeleteButtonContainer = exports.DefaultPropertySelector = exports.ColumnLayoutRoot = exports.StyledPropertySelectorGroupTable = exports.PropertySelectorGroupRows = exports.PropertySelectorGroup = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const PropertiesSelector = __importStar(require("../react-properties-selector"));
const GenesysPropertySelectorElements = __importStar(require("../genesys-property-selector-elements"));
exports.PropertySelectorGroup = styled_components_1.default.div `
  padding-right: 5px;
`;
const unStyledPropertySelectorGroupRows = (props) => {
    const restProps = __rest(props, []);
    return React.createElement("div", Object.assign({}, restProps), props.children);
};
exports.PropertySelectorGroupRows = (0, styled_components_1.default)(unStyledPropertySelectorGroupRows) `
  padding-right: 10px;
  ${props => (props.hidden ? "height: 0; visibility: hidden;" : "")};
`;
exports.StyledPropertySelectorGroupTable = styled_components_1.default.table `
  tr {
    td {
      padding-left: 10px;
      vertical-align: middle;
      white-space: nowrap;
      font-size: 12px;
      padding-top: 2px;
      padding-bottom: 2px;
    }

    td:first-child {
      padding-left: 0px;
      padding-right: 2px;
    }

    td:nth-of-type(2) {
      padding-right: 15px;
      padding-left: 0;
    }
  }
`;
exports.ColumnLayoutRoot = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
`;
exports.DefaultPropertySelector = PropertiesSelector.createPropertySelector({
    AmountPropertySelector: GenesysPropertySelectorElements.DefaultAmountPropertySelector,
    ComboboxPropertySelector: GenesysPropertySelectorElements.DefaultComboBoxPropertySelector,
    TextboxPropertySelector: GenesysPropertySelectorElements.DefaultTextboxPropertySelector,
    CheckboxPropertySelector: GenesysPropertySelectorElements.DefaultCheckboxPropertySelector
});
exports.DeleteButtonContainer = styled_components_1.default.div `
  padding-top: 10px;
  padding-bottom: 5px;
`;
exports.HelpContainer = styled_components_1.default.span `
  a {
    color: black;
  }
  a:link {
    color: black;
  }
  a:visited {
    color: black;
  }
  a:hover {
    color: black;
    text-decoration: underline;
    font-weight: bold;
  }
  a:active {
    color: black;
  }
`;
exports.PropertyContainer = styled_components_1.default.div `
  padding: 10px;
  text-align: left;
`;
exports.StyledP = styled_components_1.default.p `
  white-space: pre-wrap;
`;
exports.PropertyValueContainer = styled_components_1.default.div `
  font-weight: bold;
  padding-left: 10px;
  text-align: left;
`;
exports.PropertyValueDescription = styled_components_1.default.div `
  padding-left: 10px;
  text-align: left;
`;
//# sourceMappingURL=elements.js.map